//export const API_URL = 'http://localhost:51483';
export const API_URL = 'https://ddaysapp21web.azurewebsites.net';

export const appIsActive = true;
export const mapIsActive = true;
export const discordIsActive = true;
export const streamIsActive = true;
export const youtubeLinkDay1 = 'https://www.youtube.com/watch?v=HjEjMqCc_Zs';
export const youtubeLinkDay2 = 'https://www.youtube.com/watch?v=CBsEJVlGkzs';
export const discordLink = 'https://discord.gg/dump-days';

export const sponsorLogoExtensions = {
  ericssonnikolatesla: 'svg',
  extensionengine: 'png',
  fortunaentertainmentgroup: 'svg',
  netmedia: 'png',
  infobip: 'svg',
  five: 'svg',
  emovis: 'png',
  zagrebačkabanka: 'png',
  hrcloud: 'svg',
  littlecode: 'svg',
  typeqast: 'svg',
  blank: 'png',
  rimacautomobili: 'svg',
  undabot: 'svg',

  // Speakerske firme
  kontra: 'png',
  parklio: 'png',
  betaandco: 'svg',
  eazyoil: 'png',
  seekandhit: 'png',
  primerenderstudios: 'jpg',
  orqa: 'png',
  shape404: 'png',
  bug: 'svg',
  profico: 'svg',
  gammachef: 'svg',
  'jasno&glasno': 'jpg',
  bornfight: 'svg',

  // ostali
  fesb: 'svg',
  gradsplit: 'svg',
  hiperprodukcija: 'svg',
  studentskizbor: 'svg',
  sveučilišteusplitu: 'svg',

  // medijski
  netokracija: 'svg',
  radiokampus: 'png',
  splittechcity: 'svg',
  ultrasplit: 'png',
};

// eslint-disable-next-line no-useless-escape
export const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const groupBy = function(xs, key) {
  return xs.reduce(function(rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);

    return rv;
  }, {});
};
export const throttle = (func, limit) => {
  let inThrottle;

  return function() {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  };
};
export const shuffleArray = array => {
  let currentIndex = array.length;
  let temporaryValue;
  let randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
};
